module.exports = __webpack_public_path__ + "img/q27.46f375f0.jpg";